import { render, staticRenderFns } from "./BetSlipRiskInput.vue?vue&type=template&id=68f4d357&scoped=true&"
import script from "./BetSlipRiskInput.vue?vue&type=script&lang=js&"
export * from "./BetSlipRiskInput.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipRiskInput.vue?vue&type=style&index=0&id=68f4d357&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4d357",
  null
  
)

export default component.exports